import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-black pb-8 safe-area-bottom" data-testid="privacy-policy">
      <div className="p-6 max-w-2xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-[#C6A75E] mb-6" data-testid="back-btn">
          &#8592; Back
        </button>

        <h1 className="font-['Playfair_Display'] text-2xl text-[#C6A75E] mb-8">Privacy Policy</h1>
        
        <div className="space-y-6 text-[#F5F5F5] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Data We Collect</h2>
            <p className="text-[#888888]">We collect the following information when you use The External Blueprint:</p>
            <ul className="list-disc list-inside text-[#888888] mt-2 space-y-1">
              <li>Email address (for account creation and communication)</li>
              <li>Name (for personalization)</li>
              <li>Facial photographs (for analysis and report generation)</li>
              <li>Payment information (processed securely via Stripe)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Purpose of Data Collection</h2>
            <p className="text-[#888888]">Your data is used exclusively for:</p>
            <ul className="list-disc list-inside text-[#888888] mt-2 space-y-1">
              <li>Generating your personalized External Blueprint report</li>
              <li>Providing account access and membership services</li>
              <li>Sending your report and relevant updates (with consent)</li>
              <li>Processing payments for services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Data Storage & Security</h2>
            <p className="text-[#888888]">
              Your data is stored securely on encrypted servers. Photos are processed for analysis and stored 
              only as long as necessary to provide our services. We implement industry-standard security 
              measures to protect your information.
            </p>
            <p className="text-[#888888] mt-2">
              Uploaded images are processed securely and are not used for facial recognition or identification.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Data Sharing</h2>
            <p className="text-[#888888]">
              We do not sell, trade, or share your personal data with third parties. Your photos and 
              personal information remain confidential and are used solely for the purposes stated above.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Data Retention</h2>
            <p className="text-[#888888]">
              Your data is retained for as long as your account is active. Photos may be deleted after 
              report generation upon request. Account data is retained for legal and business purposes 
              for up to 3 years after account closure.
            </p>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Your Rights</h2>
            <p className="text-[#888888]">Under GDPR and applicable privacy laws, you have the right to:</p>
            <ul className="list-disc list-inside text-[#888888] mt-2 space-y-1">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent at any time</li>
              <li>Export your data in a portable format</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#C6A75E] font-medium mb-2">Contact</h2>
            <p className="text-[#888888]">
              For any privacy-related questions or to exercise your rights, contact us at: 
              contact@themanifestationqueen.com
            </p>
          </section>

          <p className="text-[#888888] text-xs mt-8">Last updated: April 2026</p>
        </div>

        <footer className="text-center text-[#888888] text-xs mt-12 pt-6 border-t border-[rgba(198,167,94,0.2)]">
          Created by The Manifestation Queen
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
